import React from "react";
import {
    Box,
    Button,
    Switch,
    Tooltip,
    FormControlLabel,
    Typography,
} from "@mui/material";

export type SortDirection = "ASC" | "DESC";

type Props = {
    // Sort
    sortDirection: SortDirection;
    setSortDirection: (v: SortDirection) => void;

    // Editing toggle
    editingEnabled: boolean;
    setEditingEnabled: (v: boolean) => void;
    canUseEditor: boolean;

    // zusätzliche Restriktion (Zeit/Status)
    editingAllowed?: boolean;
    editingDisabledTooltip?: string;

    showEditToggle?: boolean;
    headerAction?: {
        label: string;
        onClick: () => void;
    } | null;
};

export default function ItineraryHeaderControls({
                                                     sortDirection,
                                                     setSortDirection,
                                                     editingEnabled,
                                                    setEditingEnabled,
                                                     canUseEditor,
                                                     editingAllowed = true,
                                                     editingDisabledTooltip,
                                                     showEditToggle = true,
                                                     headerAction = null,
                                                  }: Props) {
    void sortDirection;
    void setSortDirection;

    const editDisabled = !canUseEditor || !editingAllowed;

    const editTooltip =
        !canUseEditor
            ? "Fehlende Berechtigung (vanliferuseeditor)"
            : !editingAllowed
                ? (editingDisabledTooltip ?? "Bearbeiten ist aktuell nicht möglich")
                : "";

    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                flexWrap: "wrap",
                rowGap: 1,
                columnGap: 2,
                justifyContent: "flex-end",
                mb: 2,
                pb: 1,
                minHeight: 41,
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1.5,
                    flexWrap: "wrap",
                    justifyContent: "flex-end",
                    ml: "auto",
                }}
            >
                {/* Simple Dropdown für Sortierung
                <FormControl size="small" sx={{ minWidth: 220 }}>
                    <InputLabel id="itinerary-sort-label">Sortierung</InputLabel>
                    <Select
                        labelId="itinerary-sort-label"
                        value={sortDirection}
                        label="Sortierung"
                        onChange={onSortChange}
                    >
                        <MenuItem value="ASC">Chronologisch</MenuItem>
                        <MenuItem value="DESC">Rückwärts</MenuItem>
                    </Select>
                </FormControl>
                 */}

                {headerAction && (
                    <Button size="small" variant="outlined" onClick={headerAction.onClick}>
                        {headerAction.label}
                    </Button>
                )}

                {showEditToggle && (
                    <Tooltip title={editTooltip}>
                        <span>
                          <FormControlLabel
                              sx={{ ml: 0 }}
                              control={
                                  <Switch
                                      size="small"
                                      checked={editingEnabled}
                                      onChange={(e) => setEditingEnabled(e.target.checked)}
                                      disabled={editDisabled}
                                  />
                              }
                              label={
                                  <Box sx={{ display: "inline-flex", alignItems: "center", gap: 0.5 }}>
                                      <Typography variant="body2">Bearbeiten</Typography>
                                  </Box>
                              }
                          />
                        </span>
                    </Tooltip>
                )}
            </Box>
        </Box>
    );
}
